import React from 'react';
import { HeroSection } from './sections/HeroSection';
import { AudienceSection } from './sections/AudienceSection';
import { ProblemSection } from './sections/ProblemSection';
import { SolutionSection } from './sections/SolutionSection';
import { PackSection } from './sections/PackSection';
import { AccompanimentSection } from './sections/AccompanimentSection';
import { ResultsSection } from './sections/ResultsSection';
import { DifferentialSection } from './sections/DifferentialSection';
import { OfferSection } from './sections/OfferSection';
import { LegalSection } from './sections/LegalSection';
import { Footer } from './sections/Footer';
import { StarDivider } from './ui/StarDivider';
export function LandingPage() {
  return <main className="min-h-screen w-full" data-id="element-1">
      <HeroSection data-id="element-2" />
      <StarDivider data-id="element-3" />
      <AudienceSection data-id="element-4" />
      <StarDivider data-id="element-5" />
      <ProblemSection data-id="element-6" />
      <StarDivider data-id="element-7" />
      <SolutionSection data-id="element-8" />
      <StarDivider data-id="element-9" />
      <PackSection data-id="element-10" />
      <StarDivider data-id="element-11" />
      <AccompanimentSection data-id="element-12" />
      <StarDivider data-id="element-13" />
      <ResultsSection data-id="element-14" />
      <StarDivider data-id="element-15" />
      <DifferentialSection data-id="element-16" />
      <OfferSection data-id="element-17" />
      <LegalSection data-id="element-18" />
      <Footer data-id="element-19" />
    </main>;
}